var E = /* @__PURE__ */ ((r) => (r.HD = "16:9", r.WIDE = "2.39:1", r.SQUARE = "1:1", r.VERTICAL = "4:5", r.ORIGINAL = "original", r.NORMAL = "4:3", r.SIXTOFIVE = "6:5", r.FIVETOFOUR = "5:4", r.NINETOSIXTEEN = "9:16", r))(E || {}), O = /* @__PURE__ */ ((r) => (r.LAZY = "lazy", r.EAGER = "eager", r))(O || {}), T = /* @__PURE__ */ ((r) => (r.TOP = "top", r.CENTER = "center", r.BOTTOM = "bottom", r))(T || {}), N = /* @__PURE__ */ ((r) => (r.COVER = "cover", r.CONTAIN = "contain", r))(N || {});
const A = [1, 1.5, 2, 3];
export {
  A as RocheUIImageDPI,
  N as RocheUIImageFit,
  O as RocheUIImageLoading,
  T as RocheUIImagePosition,
  E as RocheUIImageRatio
};
